import { homeStats } from "@/mocks/homeStats";

export default function HeroSection() {
  return (
    <section id="top" className="w-full border-b border-background-200">
      <div className="mx-auto grid w-full max-w-[1440px] grid-cols-1 gap-8 px-4 py-10 md:px-8 md:py-14 lg:grid-cols-2 lg:gap-12 lg:py-16">
        <div className="flex flex-col justify-center">
          <span className="mb-5 inline-flex w-fit items-center gap-2 rounded-full border border-accent-200 bg-accent-50 px-3 py-1.5 text-xs font-medium text-accent-800">
            <span className="relative flex h-1.5 w-1.5 items-center justify-center">
              <span className="absolute h-1.5 w-1.5 animate-ping rounded-full bg-accent-500/70"></span>
              <span className="h-1.5 w-1.5 rounded-full bg-accent-500"></span>
            </span>
            线索细节持续更新
          </span>

          <h2 className="font-heading text-3xl font-bold leading-snug tracking-tight text-foreground-950 md:text-4xl lg:text-[42px]">
            实锤证据，集中一处
            <br />
            截图、录音、文件都可核对
          </h2>

          <p className="mt-5 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
            汇总海角黑料实锤证据，包括截图、录音、文件等关键材料。想找海角黑料证据、核对线索细节，这里集中整理各方实锤内容，供你对比讨论。
          </p>

          <div className="mt-7 flex flex-wrap gap-3">
            <a
              href="#cases"
              className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-layout-grid-line mr-1.5 align-middle"></i>
              查看实锤汇总
            </a>
            <a
              href="#entries"
              className="cursor-pointer whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              <i className="ri-folder-open-line mr-1.5 align-middle"></i>
              进入类型入口
            </a>
          </div>

          <dl className="mt-8 grid grid-cols-2 gap-px overflow-hidden rounded-lg border border-background-200 bg-background-200 sm:grid-cols-4">
            {homeStats.map((stat) => (
              <div key={stat.id} className="bg-background-50 px-4 py-3.5">
                <dt className="text-xs text-foreground-500">{stat.label}</dt>
                <dd className="mt-1 font-heading text-xl font-bold text-foreground-950">
                  {stat.value}
                  <span className="ml-1 text-xs font-normal text-foreground-500">{stat.unit}</span>
                </dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="relative">
          <div className="relative h-[300px] w-full overflow-hidden rounded-lg border border-background-200 md:h-[420px] lg:h-full lg:min-h-[460px]">
            <img
              src="https://readdy.ai/api/search-image?query=abstract%20evidence%20dossier%20concept%20with%20floating%20folders%2C%20image%20frames%2C%20audio%20waveforms%20and%20paper%20sheets%20on%20a%20dark%20textured%20background%2C%20deep%20crimson%20and%20warm%20amber%20lighting%2C%20cinematic%20editorial%20illustration%2C%20high%20contrast%2C%20no%20text&width=1100&height=1000&seq=hjhl-hero-evidence-01&orientation=portrait"
              alt="海角黑料实锤证据材料汇总示意图"
              title="海角黑料实锤证据截图录音文件汇总"
              className="h-full w-full object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/10 to-transparent"></div>

            <div className="absolute right-4 top-4 flex items-center gap-1.5">
              <span className="rounded-full bg-background-50/90 px-2.5 py-1 text-xs font-medium text-primary-700">
                截图
              </span>
              <span className="rounded-full bg-background-50/90 px-2.5 py-1 text-xs font-medium text-accent-800">
                录音
              </span>
              <span className="rounded-full bg-background-50/90 px-2.5 py-1 text-xs font-medium text-secondary-800">
                文件
              </span>
            </div>

            <div className="absolute inset-x-4 bottom-4">
              <div className="flex flex-col gap-3 rounded-lg border border-background-200/60 bg-background-50/95 p-4 sm:flex-row sm:items-center sm:justify-between">
                <div>
                  <p className="text-xs text-foreground-500">最近一次更新</p>
                  <p className="mt-0.5 text-sm font-medium text-foreground-900">
                    09-10 09:20 · 新增 3 组截图
                  </p>
                </div>
                <a
                  href="#discuss"
                  className="inline-flex w-fit cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-secondary-100 px-3 py-2 text-xs font-medium text-secondary-900 transition-colors hover:bg-secondary-200"
                >
                  <i className="ri-chat-3-line"></i>
                  讨论区 218 条
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}